import script from "./TestView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestView.vue?vue&type=script&setup=true&lang=ts"

import "./TestView.vue?vue&type=style&index=0&id=1a0061ea&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0061ea"]])

export default __exports__